import { Theme } from "@mui/material/styles";

export const contentPageInnerStyle = (theme: Theme) => ({
  // maxWidth: "640px",
  margin: "1.5rem auto",
  padding: "2rem",
  boxSizing: "border-box",
  // background: "#fff",
  // borderRadius: "8px",
  // boxShadow: "0px 4px 4px rgba(214, 199, 186, 0.25)",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    margin: "1rem",
  },

});

export const contentFooterStyle = (theme: Theme) => ({
  padding: "1.8rem",
  textAlign: "center",
});
